import client from '../lib/http-client';

const endpoint = '/user_package';

export default {
	getPackages(cb, errorCb) {
		const url = `${endpoint}`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},
};
